import { Reducer } from 'redux';
import { CLEAR_PRIO_CACHE } from '../../../../actions';
import { ProjectId } from '../../../../models/Types';
import { SET_PROJECT_AUTO_MARK_AS_READ } from '../../actions/projects/autoMarkAsRead';

export interface AutoMarkAsReadByProjectId {
  [projectId: ProjectId]: boolean;
}

export const autoMarkAsRead: Reducer<AutoMarkAsReadByProjectId, any> = (
  state = {},
  action
) => {
  switch (action.type) {
    case SET_PROJECT_AUTO_MARK_AS_READ: {
      const {
        payload: { isEnabledByProjectId },
      } = action;
      return {
        ...state,
        ...isEnabledByProjectId,
      };
    }
    case CLEAR_PRIO_CACHE: {
      return {};
    }
    default:
      return state;
  }
};

export default autoMarkAsRead;

const EMPTY_AUTO_MARK_AS_READ_BY_PROJECT_ID: AutoMarkAsReadByProjectId = {};

export const getAutoMarkAsReadByProjectId: (
  state: AutoMarkAsReadByProjectId
) => AutoMarkAsReadByProjectId = (state) =>
  state ?? EMPTY_AUTO_MARK_AS_READ_BY_PROJECT_ID;
